import React, { useEffect } from "react";
import "../css/style.css";

function AboutIntro() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-intro-section">
      <div className="container text-center">
        <p className="about-intro-text fade-up">
          <strong className="about-intro-heading">Committed to Clean, Healthy Living</strong> 

          
              NeatNest is a trusted professional cleaning service dedicated to
      creating healthier, fresher, and stress-free living spaces. We
      specialize in high-quality home cleaning solutions that are reliable,
      affordable, and tailored to your everyday needs.

      Our trained cleaning experts use safe, eco-friendly products and modern
      techniques to deliver exceptional results. From complete home cleaning
      that removes dust and allergens, to deep kitchen cleaning that eliminates
      grease and bacteria, and hygienic bathroom cleaning for a spotless
      finish — we pay attention to every detail.
      At NeatNest, customer satisfaction is our top priority. We are committed
      to timely service, consistent quality, and maintaining the highest
      hygiene standards to ensure your home stays clean, comfortable, and
      welcoming.
    </p>
      </div>
    </section>
  );
}

export default AboutIntro;
